import { render } from "./DeliveryAddressForm.vue?vue&type=template&id=8d9c0f1c"
import script from "./DeliveryAddressForm.vue?vue&type=script&lang=js"
export * from "./DeliveryAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/DeliveryAddressForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d9c0f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d9c0f1c', __exports__)) {
    api.reload('8d9c0f1c', __exports__)
  }
  
  module.hot.accept("./DeliveryAddressForm.vue?vue&type=template&id=8d9c0f1c", () => {
    api.rerender('8d9c0f1c', render)
  })

}


export default __exports__